const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function readJson(response) {
  const body = await response.json().catch(() => ({}));
  if (response.ok) return body;
  const detail = Array.isArray(body.detail)
    ? body.detail.map((item) => item.msg).filter(Boolean).join(' ')
    : body.detail;
  throw new Error(detail || 'Something went wrong. Please try again.');
}

export async function getFamilyInterests() {
  const response = await fetch(`${BACKEND_URL}/api/v1/family-list/interests`);
  return readJson(response);
}

export async function signupForFamilyList(payload) {
  const response = await fetch(`${BACKEND_URL}/api/v1/family-list/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return readJson(response);
}
